import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import ConfirmationDialog from '~components/Dialog/ConfirmationDialog';

interface RejectLoadDialogProps {
  isBusy: boolean;
  isLoadApproved: boolean;
  lineCount: number;
  onClose: () => void;
  onConfirm: () => void;
}

export default function RejectLoadDialog({
  isBusy,
  isLoadApproved,
  lineCount,
  onClose,
  onConfirm,
}: RejectLoadDialogProps) {
  return (
    <ConfirmationDialog
      confirmButtonProps={{
        children: t('approvals.approve_charges.reject_load_dialog.confirm'),
      }}
      isBusy={isBusy}
      isOpen
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('approvals.approve_charges.reject_load_dialog.title')}
    >
      <Typography variant="body2" sx={isLoadApproved ? { mb: 1 } : undefined}>
        {t('approvals.approve_charges.reject_load_dialog.description', {
          count: lineCount,
        })}
      </Typography>
      {isLoadApproved && (
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {t('approvals.approve_charges.reject_load_dialog.unapproves')}
        </Typography>
      )}
    </ConfirmationDialog>
  );
}
